import React, { useState } from "react";
import MealItemTable from "./MealItemTable";
import { PageHeading } from "../../../components/ui/PageHeading";
import MealItemFilter from "./MealItemFilter";
import SearchInput from "../../../components/ui/SearchInput";
import { Button } from "../../../components/ui/button";
import DeleteModal from "../../../components/ui/DeleteModal";
import { useDeleteMealItemMutation } from "../../../featureSlice/mealItemSliceApi";

const MealItem = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [deleteMealItem] = useDeleteMealItemMutation();


  const handleAddClick = () => {
    setShowFilter(true);
    setEditData(null);
  };
  const handleEditClick = (row) => {
    setEditData(row);
    setShowFilter(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleDeleteAction = async (id) => {
    try {
      await deleteMealItem(id).unwrap();
    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  return (
    <div className="px-5">
      <PageHeading title="Setting >> Meal Item" className=" " />
      <div className="flex justify-end items-center pb-2">
        <div className="flex gap-4 items-center">
          <SearchInput
            value={searchTerm}
            onChange={(val) => setSearchTerm(val)}
            placeholder="Search Meal"
          />
          <Button className="bg-primary text-white" onClick={handleAddClick}>
            <span className="text-2xl pr-1">+</span> Add
          </Button>
        </div>
      </div>
      <MealItemTable
        searchTerm={searchTerm}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
      />
      {showFilter && (
        <MealItemFilter
          close={() => setShowFilter(false)}
          editData={editData}
        />
      )}
      <DeleteModal
        isOpen={isDeleteOpen}
        closeModal={() => setIsDeleteOpen(false)}
        handleDeleteAction={handleDeleteAction}
        itemId={deleteId}
      />
    </div>
  );
};

export default MealItem;
